(function () {
  'use strict';
  var TZ = 'Asia/Karachi';
  var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  function todayKarachi() {
    var y = 0, m = 0, d = 0;
    new Intl.DateTimeFormat('en-CA', { timeZone: TZ, year: 'numeric', month: '2-digit', day: '2-digit' })
      .formatToParts(new Date())
      .forEach(function (p) {
        if (p.type === 'year') { y = +p.value; }
        if (p.type === 'month') { m = +p.value; }
        if (p.type === 'day') { d = +p.value; }
      });
    return new Date(Date.UTC(y, m - 1, d));
  }

  function addWorkingDays(start, n) {
    var dt = new Date(start.getTime());
    var added = 0;
    while (added < n) {
      dt.setUTCDate(dt.getUTCDate() + 1);
      if (dt.getUTCDay() !== 0) { added++; }
    }
    return dt;
  }

  function range(a, b) {
    var am = MONTHS[a.getUTCMonth()], bm = MONTHS[b.getUTCMonth()];
    if (a.getTime() === b.getTime()) { return a.getUTCDate() + ' ' + am; }
    if (am === bm) { return a.getUTCDate() + '–' + b.getUTCDate() + ' ' + am; }
    return a.getUTCDate() + ' ' + am + ' – ' + b.getUTCDate() + ' ' + bm;
  }

  function addStyles() {
    if (document.getElementById('uy-delivery-style')) { return; }
    var s = document.createElement('style');
    s.id = 'uy-delivery-style';
    s.textContent = '.uy-delivery{display:flex;align-items:center;flex-wrap:wrap;gap:8px;margin:18px 0 0;font-size:15px;line-height:1.5;color:#222;font-weight:500}' +
      '.uy-delivery__badge{display:inline-block;padding:3px 10px;border-radius:4px;background:#e6f4ea;color:#1e6b34;font-weight:600;font-size:12px}' +
      '.npp-sizes[hidden]{display:block !important}';
    document.head.appendChild(s);
  }

  function update() {
    var today = todayKarachi();
    var nodes = document.querySelectorAll('.uy-delivery[data-uy-min]');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      var min = parseInt(el.getAttribute('data-uy-min'), 10);
      var max = parseInt(el.getAttribute('data-uy-max'), 10);
      var out = el.querySelector('.uy-delivery__dates');
      if (!out || isNaN(min) || isNaN(max)) { continue; }
      var text = range(addWorkingDays(today, min), addWorkingDays(today, max));
      if (out.textContent !== text) { out.textContent = text; }
    }
  }

  function initSizes() {
    /* Size row always visible; picking a size switches Type to Stitched */
    document.querySelectorAll('.npp-opt--split').forEach(function (fs) {
      var sizes = fs.querySelector('[data-sizes]');
      if (!sizes) { return; }
      sizes.hidden = false;
      sizes.addEventListener('change', function () {
        var st = fs.querySelector('input[data-type][value="stitched"]');
        if (st) { st.checked = true; }
      });
    });
  }

  function initProduct() {
    var dataEl = document.getElementById('uy-pd');
    var priceEl = document.querySelector('.npp-price');
    var buyEl = document.querySelector('.npp-buy');
    if (!dataEl || !priceEl) { return; }
    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var box = document.querySelector('.uy-delivery--pdp');
    if (!box) {
      box = document.createElement('div');
      box.className = 'uy-delivery uy-delivery--pdp';
      box.innerHTML = '<span class="uy-delivery__badge">Ready to ship</span><span class="uy-delivery__text">Ships <span class="uy-delivery__dates"></span></span>';
      if (buyEl) { buyEl.insertAdjacentElement('beforebegin', box); } else { priceEl.insertAdjacentElement('afterend', box); }
    }
    var badge = box.querySelector('.uy-delivery__badge');
    var render = function () {
      var idEl = document.querySelector('input[data-variant-id]');
      var id = idEl ? idEl.value : null;
      var keys = Object.keys(data.v || {});
      var r = (id && data.v[id]) || (keys.length ? data.v[keys[0]] : null);
      if (!r) { return; }
      box.setAttribute('data-uy-min', r[0]);
      box.setAttribute('data-uy-max', r[1]);
      badge.style.display = data.rts ? '' : 'none';
      update();
    };
    render();
    new MutationObserver(render).observe(priceEl, { childList: true, subtree: true, characterData: true });
    document.addEventListener('change', function () { setTimeout(render, 0); });
  }

  function init() {
    addStyles();
    initSizes();
    initProduct();
    update();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();